<style scoped lang="scss">
.page-layout {
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  .hide-menu {
    > .el-aside {
      display: none;
    }
    > .el-container > .el-main {
      padding: 0;
    }
  }

  .main-layout {
    height: 100%;
  }
}
.el-menu {
  border: none;
}

.menu-scroll {
  overflow: hidden;
  width: 125px;
}
.menu {
  height: 100%;
  // padding-top: 10px;
  padding-bottom: 80px;
  box-sizing: border-box;
  overflow-y: overlay;
  // margin-right: -15px;
  background: $color-brand-primary;
  .brand {
    display: inline-block;
    padding: 10px;
    img {
      width: 100%;
    }
  }
  .el-menu-item {
    height: 45px;
    line-height: 45px;
    padding: 0 !important;
    a {
      color: $color-brand-primary-text;
      text-decoration: none;
      display: block;
      height: 100%;
      padding: 0 20px;
    }
    &.is-active {
      background: #fff !important;
      i {
        color: $color-brand-primary;
      }
      a {
        color: #000;
      }
    }
    i {
      display: inline-block;
      width: 24px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 14px;
      color: $color-brand-accent;
    }
  }
}
.sub-menu {
  height: 100%;
  overflow-y: overlay;
  margin-right: -15px;
  padding: 10px 0;
  .el-menu-item {
    height: 38px;
    line-height: 38px;
    &:hover {
      background-color: rgba(255, 255, 255, 0.5) !important;
    }
    &.is-active {
      background: #fff !important;
    }
  }
}
.el-menu-item-group {
  padding-bottom: 20px;
}
.menu-group {
  position: relative;
  &::after {
    position: absolute;
    left: 20px;
    right: 20px;
    top: 0;
    height: 1px;
    background: #f8f8f8;
    content: '';
  }
}
.sub-menu {
  .el-menu-item-group__title {
    margin-top: 10px;
  }
  .menu-group:first-child::after {
    content: none;
  }
}
.header-con {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  .right-con {
    display: flex;
    align-items: center;
  }
  &::after {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: #e6e6e6;
    content: '';
  }
  .icon-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    transition: all 0.3s ease;
    cursor: pointer;
    &:hover {
      background: #f8f8f8;
    }
    .iconfont {
      font-size: 18px;
      line-height: 1.2;
    }
  }
  .user-setting {
    padding-left: 10px;
    > span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 50px;
    }
    .user-avatar {
      margin-right: 0;
    }
    .iconfont {
      transition: all 0.3s ease;
      // color: $dominant_hue;
      font-size: 28px;
      cursor: pointer;
    }
    &:hover {
      .iconfont {
        opacity: 0.7;
      }
    }
  }
}
.submenu-con {
  background: #f4f4f4;
  // width: 50%;
  .el-menu {
    width: 125px;
    background: #f4f4f4;
    margin-top: 10px;
  }
  .menu-group {
    padding-bottom: 0;
  }
  a {
    text-decoration: none;
    display: block;
    padding: 0 20px;
    color: #666666;
  }
  .el-menu-item {
    height: 45px;
    line-height: 45px;
    padding: 0 !important;
    &.is-active {
      background: #fff !important;
      i {
        color: $color-brand-primary;
      }
      a {
        color: #666666;
      }
    }
  }
}
.user-avatar {
  width: 40px;
  height: 40px;
  font-size: 30px;
  margin-right: 5px;
  border-radius: 50%;
}
.iframe_main {
  padding: 0;
}
</style>

<style lang="scss">
.order-num {
  padding-bottom: 5px;
  font-size: 16px;
  i {
    cursor: pointer;
  }
}
.order-store {
  color: #999;
}
.order-time {
  color: #999;
}
.sub-menu {
  .el-menu-item-group__title {
    padding-top: 20px;
  }
  .el-menu-item:hover {
    background: #f8f8f8;
  }
}
.logout-popper {
  padding: 0 !important;
  min-width: 120px !important;
  .content-padded {
    padding: 10px;
  }
  .section-footer {
    padding: 10px;
    &.with-border {
      border-top: 1px solid #efefef;
    }
  }
}
.menu-group-team {
  margin-bottom: 20px;
}

.el-main {
  &.custom_main {
    padding-bottom: 100px;
    position: relative;
  }
}
.pt50 {
  padding-top: 50px;
}
</style>

<template>
  <el-container class="page-layout">
    <el-header height="50px">
      <SpGlobalHeader />
    </el-header>
    <el-container
      :class="{ 'hide-menu': hideMenu }"
      class="main-layout"
    >
      <el-aside width="264px">
        <SpShopMenu :menu-list="menuList" />
      </el-aside>
      <el-container>
        <el-main class="custom_main">
          <SpNotice @closeBlank="handleClose" />
          <!-- <div class="pt50" v-if="isShow"></div> -->
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'
import mixin from '@/mixin'
export default {
  mixins: [mixin],
  data () {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapState({
      menuList: (state) => state.menu.menus
    }),
    hideMenu () {
      const { hideMenu } = this.$route.meta
      if (typeof hideMenu != 'undefined' && !hideMenu) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.isShow =
      localStorage.getItem('isShowTopNotice') === 'true' ||
      localStorage.getItem('isShowTopNotice') == null
  },
  methods: {
    handleClose (value) {
      this.isShow = value
    }
  }
}
</script>
